import theme from 'theme';

export const previewContainerStyles = {
    border: `2px solid ${theme.palette.primary.main}`,
    borderRadius: 4,
    minHeight: '520px',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
};

// Real WhatsApp header: dark teal background, white controls
export const previewHeaderStyles = {
    minHeight: 72,
    backgroundColor: theme.palette.primary.main, // #123133 — matches WhatsApp dark header
    borderRadius: '14px 14px 0 0',
    px: 1,
};

export const messageAreaStyles = {
    flexGrow: 1,
    // WhatsApp chat background: light warm green
    backgroundColor: '#ECE5DD',
    px: 2,
    py: 1,
    overflowY: 'auto',
};

export const messageDescriptorStyles = {
    color: '#6b7b80',
    textAlign: 'center',
    mb: 1,
    fontSize: '0.65rem',
    textTransform: 'none',
    letterSpacing: 0,
};

export const messageBubbleStyles = {
    borderRadius: '20px',
    p: 2,
    maxWidth: '75%',
    alignSelf: 'flex-start',
    position: 'relative',
    marginBottom: '10px',
};

const sharedMessageBubbleBeforeStyles = {
    // This creates the actual tail shape
    content: '""',
    position: 'absolute',
    zIndex: 0,
    bottom: 0,
    height: '20px',
    width: '20px',
};

const sharedMessageBubbleAfterStyles = {
    // This masks part of the tail to create the curved effect
    content: '""',
    position: 'absolute',
    zIndex: 1,
    bottom: 0,
    width: '10px',
    height: '20px',
};

export const sentMessageBubbleStyles = {
    backgroundColor: '#34C759',
    '&::before': {
        ...sharedMessageBubbleBeforeStyles,
        right: '-7px',
        backgroundColor: '#34C759',
        borderBottomLeftRadius: '15px',
    },
    '&::after': {
        ...sharedMessageBubbleAfterStyles,
        backgroundColor: `${theme.palette.common.white}`,
        right: '-10px',
        borderBottomLeftRadius: '10px',
    },
};

// Received bubble: white background with dark text (real WhatsApp incoming message)
export const receivedMessageBubbleStyles = {
    backgroundColor: '#FFFFFF',
    '&::before': {
        ...sharedMessageBubbleBeforeStyles,
        left: '-7px',
        backgroundColor: '#E5E5EA',
        borderBottomRightRadius: '15px',
    },
    '&::after': {
        ...sharedMessageBubbleAfterStyles,
        left: '-10px',
        backgroundColor: `${theme.palette.common.white}`,
        borderBottomRightRadius: '10px',
    },
};

export const messageTextStyles = {
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    width: '100%',
    color: '#111B21', // WhatsApp message text: near-black
    fontSize: '0.85rem',
};

export const inputAreaStyles = {
    pointerEvents: 'none',
    p: 2,
    backgroundColor: `${theme.palette.common.white}`,
    alignItems: 'center',
    borderRadius: 4,
};

export const inputFieldStyles = {
    flex: 1,
    border: `0.5px solid #3C3C435C`,
    borderRadius: '30px',
    paddingLeft: 2,
    minHeight: '36px',
    alignItems: 'center',
    justifyContent: 'space-between',
};
